'use client'
import { useEffect } from 'react'
import { reportClientError } from '@/lib/platform/clientLogger'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }, reset: () => void }) {
  useEffect(() => {
    void reportClientError(error, {
      level: 'critical',
      context: { boundary: 'global-error', digest: error.digest ?? null },
    })
  }, [error])

  return (
    <html><body>
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Algo deu errado</h2>
        <button onClick={() => reset()}>Tentar novamente</button>
      </div>
    </body></html>
  )
}
